export default "__VITE_ASSET__BXX7jAro__"